import yup from '../../helpers/yupInstance';
import type { TFunction } from 'i18next';
import { PasswordRegex } from '../../shared/constants';

export function getResetPasswordFormValidation(t: TFunction) {
  return yup.object({
    password: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.passwordRequired'))
      .min(8, t('formikValidation.passwordMin'))
      .matches(PasswordRegex, t('formikValidation.passwordPattern')),
    confirmPassword: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .oneOf([yup.ref('password')], t('formikValidation.confirmPasswordMatch')),
  });
}
